import mutations from "@/modules/dashboard/store/mutations";
import getters from "@/modules/dashboard/store/getters";
import actions from "@/modules/dashboard/store/actions";

export default {
    state: {},
    actions: actions,
    getters: getters,
    mutations: mutations
}